function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fish_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "fish"
}, /*#__PURE__*/React.createElement("path", {
  className: "fish_fill",
  d: "M.5,35.15c0-6.31,1.7-12.23,4.65-17.32C11.14,7.47,22.32,.5,35.15,.5s24.01,6.97,30,17.32c-5.99,10.35-17.18,17.32-30,17.32S11.14,28.18,5.15,17.82C2.2,12.73,.5,6.81,.5,.5V35.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fish_stroke",
  d: "M.5,35.15c0-6.31,1.7-12.23,4.65-17.32C11.14,7.47,22.32,.5,35.15,.5s24.01,6.97,30,17.32c-5.99,10.35-17.18,17.32-30,17.32S11.14,28.18,5.15,17.82C2.2,12.73,.5,6.81,.5,.5V35.15Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "fish_stroke",
  x1: 46.56,
  y1: 2.43,
  x2: 46.56,
  y2: 33.22
}), /*#__PURE__*/React.createElement("circle", {
  className: "fish_stroke",
  cx: 55.85,
  cy: 17.82,
  r: 2.32
}));

var SvgFish = function SvgFish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fishIcon",
    viewBox: "-2 -2 69.72 39.65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fish.983e2bf8.svg";
export { ForwardRef as ReactComponent };